<script setup lang="ts">
import type { IStatusMessageProps } from './types'

withDefaults(defineProps<IStatusMessageProps>(), {
  iconSize: 48,
})
</script>

<template>
  <div class="flex flex-1 flex-col items-center justify-center text-center p-6">
    <component
      v-if="icon"
      :is="icon"
      :size="iconSize"
      class="mb-3 text-muted-foreground"
    />
    <h2 class="text-lg font-semibold mb-2 text-foreground">
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="text-sm leading-relaxed text-muted-foreground max-w-xs"
    >
      {{ description }}
    </p>
    <slot />
  </div>
</template>
